export default __webpack_public_path__ + "static/media/ponto_4.e04bacd1.svg";